import { message } from 'antd';
import { put, select, takeLatest } from 'redux-saga/effects';
import { RootState } from 'data';
import { StoreActionProps } from 'data/core';
import { logger } from 'services';
import { rlNavigation } from 'utils/navigation';
import {
  updateSpaceInProjectTemplate,
  MinSpaceIdInProjectTemplatePayload,
} from '../../actions';
import { updateProjectTemplateSpace } from '../../slices';
import { ProjectTemplate, ProjectTemplateSpace } from '../../types';

const selectSpace =
  (id: number) =>
  ({ templates }: RootState): ProjectTemplateSpace =>
    templates.project.data[templates.project.activeId].spaceList[id];

const selectActiveTemplate =
  () =>
  ({ templates }: RootState): ProjectTemplate =>
    templates.project.data[templates.project.activeId].template;

function* updateSpaceInTemplateSaga(
  action: StoreActionProps<MinSpaceIdInProjectTemplatePayload>,
) {
  try {
    const { payload } = action;

    const activeTemplate: ProjectTemplate = yield select(
      selectActiveTemplate(),
    );
    const space: ProjectTemplateSpace = yield select(
      selectSpace(payload.space.spaceId),
    );

    yield put(updateProjectTemplateSpace(payload.space));

    if (space.isNew) {
      yield rlNavigation.push(
        `/templates/projects/${activeTemplate.templateId}/spaces/${payload.space.spaceId}/tabs/new`,
      );
    }
  } catch (error) {
    logger.error('an error updating the space', { error });

    message.error('There was an error updating the space');
  }
}

export function* watchUpdateSpaceInProjectTemplateSaga(): Generator {
  yield takeLatest(
    updateSpaceInProjectTemplate.type,
    updateSpaceInTemplateSaga,
  );
}
